import React from "react";
import "./Service.css";
import loanImg from "../../Assets/loan.png";
import peopleImg from "../../Assets/people.png";

const Service = () => {
  const serviceData = [
    {
      id: 0,
      img: loanImg,
      text: "PM'S YOUTH BUSINESS & AGRICULTURE LOAN SCHEME",
      btnText: "APPLY FOR LOAN",
    },
    {
      id: 1,
      img: loanImg,
      text: "Application Form for Agricultural Machinary Financing",
      btnText: "APPLY FOR LOAN",
    },
    {
      id: 2,
      img: loanImg,
      text: "Youth Organizations Registration",
      btnText: "REGISTER NOW",
    },
    {
      id: 3,
      img: peopleImg,
      text: "Talent Hunt Youth Sports League",
      btnText: "APPLY NOW",
      btnText1: "SEE DETAILS",
    },
    {
      id: 4,
      img: peopleImg,
      text: "Online Career Advisory",
      btnText: "SEE DETAILS",
    },
    {
      id: 5,
      img: peopleImg,
      text: "Prime Minister's Youth Skill Development Program",
      btnText: "APPLY NOW",
    },
    {
      id: 6,
      img: peopleImg,
      text: "National Youth Council",
      btnText: "APPLY NOW",
    },
  ];
  return (
    <>
      <div className="service-container">
        {serviceData.map((items) => {
          return (
            <div key={items.id} className="service-box">
              <img src={items.img} alt="" />
              <div className="service-card">
                <h3>{items.text}</h3>
                <button>{items.btnText}</button>
                {items.btnText1 === "SEE DETAILS" ? (
                  <>
                    <button>{items.btnText1}</button>
                  </>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Service;
